import React from "react";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Header = ({ NoProfileIcon, resetPass, resetPassAlumni, contact }) => {
    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear();
        toast.success("Logged out");
        navigate("/");
    };

    const user = {
        isAlumniCoordinator:
            localStorage.getItem("is_alumni_coordinator") === "true",
        isPricipal: localStorage.getItem("is_principal") === "true",
        department: localStorage.getItem("department"),
        isHod: localStorage.getItem("is_hod") === "true",
    };

    return (
        <nav className="flex flex-col gap-2 sm:flex-row justify-between items-center bg-[#1b114e] p-1.5 pl-2 pr-2 sm:pr-10 sm:pl-10 w-full fixed top-0 z-20">
            <div
                onClick={() => {
                    if (
                        user.isAlumniCoordinator ||
                        user.isHod ||
                        user.isPricipal
                    ) {
                        navigate("/view-applicants");
                    } else {
                        navigate("/personal-details");
                    }
                }}
                className="flex items-start gap-3 font-bold text-white m-1 cursor-pointer"
            >
                <img
                    src={logo}
                    alt="Logo"
                    className="w-12 h-14"
                    loading="lazy"
                />
                <div className="">
                    <div className="sm:text-lg text-base">
                        PSG Alumni Association
                    </div>
                    <div className="sm:text-sm text-xs">Coimbatore</div>
                </div>
            </div>

            <div className="flex flex-row items-center justify-center gap-4">
                {!contact && (
                    <div
                        onClick={() => navigate("/contact")}
                        class="relative inline-flex items-center justify-center p-4 px-4 sm:py-2 py-1  overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out border-2 border-white rounded-full shadow-md group cursor-pointer text-sm sm:text-base"
                    >
                        <span class="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full bg-white group-hover:translate-x-0 ease">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 16"
                                width="24px"
                                height="24px"
                            >
                                <path d="M1,1v14h14V1H1z M8,4c1.105,0,2,0.895,2,2c0,1.105-0.895,2-2,2S6,7.105,6,6C6,4.895,6.895,4,8,4z M12,13H4v-1	c0-1.105,0.895-2,2-2h4c1.105,0,2,0.895,2,2V13z" />
                            </svg>
                        </span>
                        <span class="absolute flex items-center justify-center w-full h-full text-white transition-all duration-300 transform group-hover:translate-x-full ease font-bold">
                            Contact
                        </span>
                        <span class="relative invisible">Contact</span>
                    </div>
                )}
                {!NoProfileIcon && (
                    <div
                        onClick={logout}
                        class="relative inline-flex items-center justify-center p-4 px-4 sm:py-2 py-1  overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out border-2 border-white rounded-full shadow-md group cursor-pointer text-sm sm:text-base"
                    >
                        <span class="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full bg-white group-hover:translate-x-0 ease">
                            <svg
                                class="w-6 h-6"
                                fill="none"
                                stroke="#1b114e"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                                ></path>
                            </svg>
                        </span>
                        <span class="absolute flex items-center justify-center w-full h-full text-white transition-all duration-300 transform group-hover:translate-x-full ease font-bold">
                            Log out
                        </span>
                        <span class="relative invisible">Log out</span>
                    </div>
                )}
                {!resetPass && (
                    <div
                        onClick={() => navigate("/reset-password-profile")}
                        class="relative inline-flex items-center justify-center p-4 px-4 py-1 sm:py-2 overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out border-2 border-white rounded-full shadow-md group cursor-pointer text-center text-sm sm:text-base"
                    >
                        <span class="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full bg-white group-hover:translate-x-0 ease">
                            <svg
                                class="w-6 h-6"
                                viewBox="0 0 21 21"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g
                                    fill="none"
                                    fill-rule="evenodd"
                                    strokeWidth={2}
                                    stroke="#000000"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    transform="matrix(0 1 1 0 2.5 2.5)"
                                >
                                    <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8" />

                                    <path
                                        d="m4 1v4h-4"
                                        transform="matrix(1 0 0 -1 0 6)"
                                    />
                                </g>
                            </svg>
                        </span>
                        <span class="absolute flex items-center justify-center w-full h-full text-white transition-all duration-300 transform group-hover:translate-x-full ease font-bold">
                            Reset Password
                        </span>
                        <span class="relative invisible">Reset Password</span>
                    </div>
                )}
                {!resetPassAlumni && (
                    <div
                        onClick={() =>
                            navigate("/reset-password-profile-alumni")
                        }
                        class="relative inline-flex items-center justify-center p-4 px-4 py-1 sm:py-2 overflow-hidden font-medium text-indigo-600 transition duration-300 ease-out border-2 border-white rounded-full shadow-md group cursor-pointer text-center text-sm sm:text-base"
                    >
                        <span class="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full bg-white group-hover:translate-x-0 ease">
                            <svg
                                class="w-6 h-6"
                                viewBox="0 0 21 21"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g
                                    fill="none"
                                    fill-rule="evenodd"
                                    strokeWidth={2}
                                    stroke="#000000"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    transform="matrix(0 1 1 0 2.5 2.5)"
                                >
                                    <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8" />

                                    <path
                                        d="m4 1v4h-4"
                                        transform="matrix(1 0 0 -1 0 6)"
                                    />
                                </g>
                            </svg>
                        </span>
                        <span class="absolute flex items-center justify-center w-full h-full text-white transition-all duration-300 transform group-hover:translate-x-full ease font-bold">
                            Reset Password
                        </span>
                        <span class="relative invisible">Reset Password</span>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Header;
